import { CreateCustomerRequest } from "./createCustomerRequest";

export class RegisterCustomerRequest extends CreateCustomerRequest{
    
    public password? : string;

    constructor(){
        super();
    }
}